<template>
  <v-card class="rounded-xl" color="cardOne" id="card-main">
    <v-container
      :class="$vuetify.breakpoint.name == 'xs' ? '' : 'pr-8 pl-8'"
      fluid
    >
      <v-row align="center" id="header">
        <v-col cols="2" sm="2" xs="2" md="2" lg="2" xl="2">
          <v-img
            class="ml-2"
            :aspect-ratio="16 / 9"
            width="120"
            :src="require('../assets/logo-header2.png')"
          ></v-img>
        </v-col>
        <v-col cols="3" sm="3" xs="3" md="3" lg="3" xl="3">
          <v-card
            class="rounded-xl"
            elevation="0"
            v-if="profile && token != ''"
          >
            <v-list-item two-line>
              <v-list-item-avatar>
                <v-menu bottom min-width="200px" rounded offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-large v-on="on">
                      <v-avatar color="grey" size="60">
                        <img :src="user.imagen" />
                      </v-avatar>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-list-item-content class="justify-center">
                      <div class="mx-auto text-center">
                        <v-avatar color="grey" size="60">
                          <img :src="user.imagen" />
                        </v-avatar>
                        <h3>{{ user.Nombres }} {{ user.Apellidos }}</h3>
                        <p class="caption mt-1">
                          {{ user.email }}
                        </p>
                        <v-divider class="my-3"></v-divider>
                        <!-- <v-btn
                        depressed
                        rounded
                        text
                      >
                        Edit Account
                      </v-btn> -->
                        <!-- <v-divider class="my-3"></v-divider> -->
                        <div  v-if="user.borrado !== '1'">
                          <v-btn
                            @click="changePassword()"
                            depressed
                            rounded
                            text
                            class="black--text rounded-lg font-weight-regular"
                          
                          >
                            Cambiar contraseña
                          </v-btn>
                          <v-divider class="my-3"></v-divider>
                        </div>
                        <v-btn
                          @click="logout()"
                          depressed
                          rounded
                          text
                          class="black--text rounded-lg font-weight-regular"
                        >
                          Salir
                        </v-btn>
                      </div>
                    </v-list-item-content>
                  </v-card>
                </v-menu>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle
                  >Bienvenid@

                  
                  <div class="row ml-0">

                   <star-rating
                    v-model= "rating"
                    v-bind:increment="0.01"
                    v-bind:max-rating="5"
                    inactive-color="#f1f1f1"
                    active-color="#FFD700"
                    v-bind:star-size="20"
                    v-bind:read-only="true"
                    v-bind:show-rating="false"
                  >
                   
                  </star-rating>

                  <div class="ml-3">
                    <p class="mt-4"> {{rating.toFixed(1)}}</p>
                  </div>

                </div>
              
                </v-list-item-subtitle>  
                <v-list-item-title style="font-size:.8rem;"
                  ><strong>Reputación Institucional</strong></v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="7" sm="7" xs="7" md="7" lg="7" xl="7">
          <p
            class="text-right text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text font-weight-light mr-5"
          >
            Autogestión
            
          </p>
          <p
            class="text-right"
          >
          <!--
          <a href="https://sistemaiea.com/public.login.php?var=entry&redirect=0" style="text-decoration: none;">Volver a la versión anterior</a>
          --> 
          </p>

        </v-col>
      </v-row>
      <v-row align="center">

        <slot></slot>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import StarRating from 'vue-star-rating'
export default {
  props: {
    profile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rating: 1.0,
    };
  },
  components: {
    StarRating,
  },
  mounted() {

      this.$API
        .get({
          url: "usuario/puntaje",
          data: {},
        })
        .then((res) => {
          
            this.rating = res.puntaje != null ? res.puntaje : 1.0;
          
        });
    
  },
  computed: {

    token() {
      return this.$store.getters.token;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "usuario/logout",
          data: {},
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    async changePassword() {
      this.$router.push({
            name: 'ChangePassword'
          });  
    }
  }
};
</script>
